import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IAggregateBusinessRepository } from '@/coreInfrastructureModule/interfaces/IAggregateBusinessRepository';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';

/**
 * 置き場名を取得するユースケース
 * @param warehouse - 置き場情報
 */
export class GetWarehouseNameUseCase {
  private repository: IAggregateBusinessRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IAggregateBusinessRepository) {
    this.repository = repository;
  }
  /**
   * 置き場名を取得する
   * @param warehouseNumber - 置き場番号
   */
  async execute(warehouseNumber: string): Promise<INetworkResult<string | undefined, IError>> {
    try {
      const result = await this.repository.getWarehouseName(warehouseNumber);
      return result;
    } catch (error) {
      console.error(error);
      return {
        status: {
          type: 'error',
          error: {
            message: '想定外のエラーが発生しました',
            statusCode: 0,
            code: '',
          },
        },
      };
    }
  }
}
